<template>
  <div>
    <div>
      <div>
        <v-layout wrap>
          <v-flex xs12 sm12 md12 lg12 xl12 >
            <v-toolbar color="primary" dark >
              <v-toolbar-title>Tổng hợp dữ liệu</v-toolbar-title>
              <v-spacer/>
              <v-btn color="blue" @click="downloadPDF">
                {{ $t("Export") }}
              </v-btn>
            </v-toolbar>
          </v-flex>
        </v-layout>
      </div>
      <div id="content-to-pdf">
        <v-layout wrap>
<!--          <v-flex xs12 sm12 md12 lg12 xl12 >-->
<!--            <div class="report">-->
<!--              Báo cáo tổng hợp-->
<!--            </div>-->
<!--          </v-flex>-->
          <v-flex xs12 sm12 md12 lg12 xl12 >
            <v-layout wrap>
              <v-flex xs6 sm6 md6 lg6 xl6 style="margin: 40px; border-radius: 30px; background: #ece8e7; opacity: 80%">
                <div class="chart-container">
                  <gru-chart id="summary_week"
                             type="pie"
                             label=""
                             query="getSoluongTrangthai"
                             :label="label1"
                             label-field="Trạng thái"
                             index-field="Số lượng"
                             @clickPart="clickPart"
                             @clickOut="clickOut"

                  />
                </div>

              </v-flex>

              <v-flex xs3 sm3 md3 lg3 xl3 style="margin: 40px; margin-left: 80px; border-radius: 30px; background: #ece8e7; opacity: 80%">
                <div class="wrap1">
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 5px">
                      <div class="text-title" align="center" style="font-size: x-large; font-weight: bold; padding-top: 30px">Khung tổng quan</div>
                    </v-flex>
                    <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 5px; height: 120px" class="wrap1">
                      <div class="text-title" align="center">Số lớp đang học</div>
                    </v-flex>
                    <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 5px; height: 120px" class="wrap2">
                      <div class="circle">{{totalClass}}</div>
                    </v-flex>
                    <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 5px; height: 120px" class="wrap1">
                      <div class="text-title" align="center">Tổng thời gian học video</div>
                    </v-flex>
                    <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 5px; height: 120px" class="wrap2">
                      <div class="circle">{{countThoiluongVideo}}</div>
                    </v-flex>
                    <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 5px; height: 120px" class="wrap1">
                      <div class="text-title" align="center">Tổng số từ vựng</div>
                    </v-flex>
                    <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 5px; height: 120px" class="wrap2">
                      <div class="circle">{{countSoluongTuvung}}</div>
                    </v-flex>
                    <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 5px; height: 120px" class="wrap1">
                      <div class="text-title" align="center">Tổng số trò chơi đã học</div>
                    </v-flex>
                    <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 5px; height: 120px" class="wrap2">
                      <div class="circle">{{countSoluongTrochoi}}</div>
                    </v-flex>
                  </v-layout>
                </div>




              </v-flex>
            </v-layout>

          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12 style="border-radius: 30px;">
            <v-layout wrap>
              <v-flex xs10 sm10 md10 lg10 xl10 style="margin: 40px; border-radius: 30px; background: #ece8e7; opacity: 80%">
                <v-layout wrap style="">
<!--                  <v-flex xs11 sm11 md11 lg11 xl11 style="">-->
<!--                    <div class="detail">-->
<!--                      Tỷ lệ hoàn thành bài học trung bình-->
<!--                    </div>-->
<!--                  </v-flex>-->
                  <v-flex xs11 sm11 md11 lg11 xl11 style="padding: 40px">
                    <div class="chart-container">
                      <school-general-chart id="summary_week2"
                                 type="horizontalBar"
                                 label=""
                                 query="getTylehoanthanhbaihoc"
                                 :label="label1"
                                 label-field="Trạng thái"
                                 index-field="Số lượng"

                      />
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>



        </v-layout>
      </div>
    </div>


  </div>

</template>
<script>
  import GruChart from "@/components/form/GruChart";
  import jsPDF from "jspdf";
  import html2canvas from "html2canvas";
  import axios from "axios";
  import SchoolGeneralChart from "@/components/form/SchoolGeneralChart";
  export default {
    components: {SchoolGeneralChart, GruChart},
    data() {
      return {
        label1: [
          {label: "thứ 2", color: "#808AC3"},
          {label: "thứ 3", color: "#4958A9"},
          {label: "thứ 4", color: "#162778"},
          {label: "thứ 5", color: "green"},
          {label: "thứ 6", color: "violet"},
          {label: "thứ 7", color: "gray"},
          {label: "chủ nhật", color: "purple"},
          {label: "nghỉ", color: "brown"},
        ],
        title: "Tổng số lớp học tiếng anh: 381",
        chuong:135,
        baihoc: 270,
        phanhoc: 1150,
        tuvung: 1234,
        maucau: 112,
        trochoi: 131,
        video: 68,
        totalClass: 0,
        countSoluongTuvung: 0,
        countSoluongMaucau: 0,
        countSoluongTrochoi:0,
        countSoluongvideo:0,
        countThoiluongVideo:0,
        count34 :0,
        count45: 0,
        count56: 0,
        thoiluong: "50h25p",
        search: {
          fromDate: (new Date()).setDate(new Date().getDate() - 6 * 30),
          toDate: new Date(),
        },
      }
    },
    created() {
      this.title = "Tổng số lớp học tiếng anh: 382";
      this.formattedFromDate = new Date(this.search.fromDate).toLocaleDateString("vi-VN");
      this.formattedToDate = new Date(this.search.toDate).toLocaleDateString("vi-VN");
    },
    mounted(){
      this.formattedFromDate = new Date(this.search.fromDate).toLocaleDateString("vi-VN");
      this.formattedToDate = new Date(this.search.toDate).toLocaleDateString("vi-VN");
      this.getData();
    },
    methods: {
      // clickPart (label){
      //   if (label && label.toLowerCase().includes("level 1")) {
      //     this.chuong = 30;
      //     this.baihoc=  80;
      //     this.phanhoc = 350;
      //     this.tuvung = 356;
      //     this.maucau = 25;
      //     this.trochoi = 28;
      //     this.video = 17;
      //     this.thoiluong = "12h09p";
      //     document.querySelectorAll('.circle').forEach(el => {
      //       el.style.backgroundColor = '#808AC3';
      //     });
      //     document.querySelectorAll('.circle').forEach(el => {
      //       el.style.color = 'white';
      //     });
      //   } else if (label && label.toLowerCase().includes("level 2")) {
      //     this.chuong = 45;
      //     this.baihoc=  90;
      //     this.phanhoc = 380;
      //     this.tuvung = 410;
      //     this.maucau = 38;
      //     this.trochoi = 44;
      //     this.video = 21;
      //     this.thoiluong = "17h12p";
      //     document.querySelectorAll('.circle').forEach(el => {
      //       el.style.backgroundColor = '#4958A9';
      //     });
      //     document.querySelectorAll('.circle').forEach(el => {
      //       el.style.color = 'white';
      //     });
      //   } else if (label && label.toLowerCase().includes("level 3")) {
      //     this.chuong = 60;
      //     this.baihoc=  100;
      //     this.phanhoc = 420;
      //     this.tuvung = 468;
      //     this.maucau = 49;
      //     this.trochoi = 59;
      //     this.video = 30;
      //     this.thoiluong = "21h04p";
      //     document.querySelectorAll('.circle').forEach(el => {
      //       el.style.backgroundColor = '#162778';
      //     });
      //     document.querySelectorAll('.circle').forEach(el => {
      //       el.style.color = 'white';
      //     });
      //   } else{
      //     this.clickOut();
      //   }
      // },
      // clickOut (){
      //   this.chuong = 135;
      //   this.baihoc=  270;
      //   this.phanhoc = 1150;
      //   this.tuvung = 1234;
      //   this.maucau = 112;
      //   this.trochoi = 131;
      //   this.video = 68;
      //   this.thoiluong = "50h25p";
      //   document.querySelectorAll('.circle').forEach(el => {
      //     el.style.backgroundColor = '#BAC3FF';
      //   });
      //   document.querySelectorAll('.circle').forEach(el => {
      //     el.style.color = '#00105A';
      //   });
      // },
      getData(){
        axios.post(
            process.env.VUE_APP_API_URL + "/chart/getGeneralInfo/", this.search
        )
            .then(
                (data) => {
                  this.countSoluongTuvung = data.countSoluongTuvung;
                  this.countSoluongMaucau = data.countSoluongMaucau;
                  this.countSoluongTrochoi = data.countSoluongTrochoi;
                  this.countSoluongvideo = data.countSoluongvideo;
                  this.countThoiluongVideo = data.countThoiluongVideo;
                  this.count34 = data.count34;
                  this.count45 = data.count45;
                  this.count56 = data.count56;
                  this.schoolName = data.schoolName;
                  this.username = data.username;
                  this.totalClass = this.count34 + this.count45 + this.count56;
                  let sum = 1;
                  if(this.totalClass > 0){
                    sum = this.totalClass;
                  }

                }
            );
      },
      async downloadPDF() {
        const element = document.getElementById("content-to-pdf");
        const canvas = await html2canvas(element);
        const imgData = canvas.toDataURL("image/png");

        // const pdf = new jsPDF("p", "mm", "a4");
        // pdf.addImage(imgData, "PNG", 10, 10, 190, 0);
        // pdf.save("download.pdf");

        // Create a PDF in Landscape mode
        const pdf = new jsPDF("landscape", "mm", "a4"); // 'landscape' mode
        const imgWidth = 297; // A4 width in mm (landscape)
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 10, 10, imgWidth - 20, imgHeight);
        pdf.save("Baocaochung.pdf");
      }
    }
  }

</script>

<style scoped>
.circle {
  width: 80px;
  height: 80px;
  background-color: #BAC3FF;
  color: #00105A;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-weight: bold;
  font-size: 22px;
  text-align: center;
}
.circle2 {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 24px;
  text-align: center;

}
.wrap1 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: large;
}
.wrap2 {
  display: flex;
  /*justify-content: center;*/
  align-items: center;
}
.report {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: xxx-large;
}
.detail {
  padding-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: x-large;
  font-weight: bold;
}
.chart-container {
  padding-top: 30px;
  padding-bottom: 30px;
  //background: #ece8e7;
}
</style>
